import { PnlCategoriesEnum } from "types/enums";
import { CHANGEOVER_DOWNTIME } from "./constants";
import { ONE_DAY_OF_MS } from "utils/timeUtils";
import { DataDumpAggregateType } from "types/types";

// ** this is NOT USED anywhere except for internal tracking of customer counts
export const CUSTOMERS_WHO_HAVE_TARGETS = [
  "dt",
  "nb",
  "pci",
  "qi",
  "qi2",
  "qi3",
  "quepasa",
  "sands",
];
// ** this is NOT USED anywhere except for internal indicator on customer tiles page
export const CUSTOMERS_WITH_SERIAL_PROCESSES = ["kruger"];
// ** this is NOT USED anywhere except for internal tracking of customer counts
// TECHDEBT: please update this list
export const CUSTOMERS_WITH_COUNTS_ON_TILES = ["lb", "pci"];

// A future midgard config
// these categories get hidden from the PNL chart (possibly other charts in future)
export const CATEGORIES_TO_HIDE_PER_CUSTOMER = {
  pnl_chart_test_user_1: [
    PnlCategoriesEnum.producing,
    PnlCategoriesEnum.uncollected,
    PnlCategoriesEnum.notScheduled,
  ],
};

export const HIDE_NET_OUTPUT_VALUE = {};

export const CUSTOMER_UNITS_DISPLAY_NAMES_BY_MACHINE: {
  [ckey: string]: { [machineId: string]: string };
} = {};

type OneCustomBottomRowItemType = {
  /** customize for one process (use the machemetryId) or all processes (use "ALL_PROCESSES") */
  [processIdOrALL_PROCESSES: string]: {
    /** use `dataDumpName` to grab a custom value to represent "counts" the data dump (defaults to `netOutput`) */
    dataDumpName?: string;
    /** customize the units at the bottom row of the item (defaults to "parts" for item1, item3 or "%" for item2) */
    displayName: string;
    /** customize the numerator used in rate calculation (CurrentRateTracker.tsx) (defaults to same as item1.dataDumpName) */
    numeratorDataDumpName?: keyof DataDumpAggregateType;
  };
};

type CustomTargetRateType = {
  units?: string;
  decimalPoints?: number;
};

/** customize item 1, 2, or 3 (left, middle, right) of Hublet view */
export type CustomBottomRowItemsType = {
  /** bottom-left metric */
  item1?: OneCustomBottomRowItemType;
  /** bottom-center metric */
  item2?: OneCustomBottomRowItemType;
  /** bottom-right metric */
  item3?: OneCustomBottomRowItemType;
  targetRate?: CustomTargetRateType;
};

// TODO: why is ticksPortX replacing the default output?
/** @deprecated - prefer Midgard flightConfig
 *
 * customize bottom-row-items in the Details/Hublet view
 * item1, item2, item3 = left, center, right
 * use ALL_PROCESSES to customize all processes at once
 */
export const CUSTOMERS_WITH_CUSTOM_DETAILS_VIEW_BOTTOM_ITEMS: {
  [ckey: string]: CustomBottomRowItemsType;
} = {
  yamamotoyama: {
    item1: {
      ALL_PROCESSES: {
        displayName: "net count",
      },
    },
    item2: {
      yamamotoyama_d_007: {
        dataDumpName: "EMPTY",
        displayName: "EMPTY",
      },
    },
    item3: {
      ALL_PROCESSES: {
        displayName: "net count",
      },
    },
  },
  quepasa: {
    item1: {
      ALL_PROCESSES: {
        displayName: "pallets",
      },
    },
    item3: {
      ALL_PROCESSES: {
        displayName: "pallets",
      },
    },
  },
  sands: {
    item1: {
      ALL_PROCESSES: {
        displayName: "feet",
      },
    },
    item3: {
      ALL_PROCESSES: {
        displayName: "feet",
      },
    },
    targetRate: { units: "strokes" },
  },
  nb: {
    item1: {
      ALL_PROCESSES: {
        displayName: "articles",
      },
    },
    item3: {
      ALL_PROCESSES: {
        displayName: "articles",
      },
    },
  },
  nwmason: {
    item1: {
      ALL_PROCESSES: {
        displayName: "bottles",
      },
    },
    item3: {
      ALL_PROCESSES: {
        displayName: "bottles",
      },
    },
  },
  nwmason2: {
    item1: {
      ALL_PROCESSES: {
        displayName: "trays",
      },
    },
    item3: {
      ALL_PROCESSES: {
        displayName: "trays",
      },
    },
  },
  renaissance: {
    item1: {
      ALL_PROCESSES: { displayName: "Parts" },
    },
    item3: {
      ALL_PROCESSES: { displayName: "Parts" },
    },
    targetRate: { decimalPoints: 1 },
  },
  lb: {
    item1: {
      lb_d_01_1_0: {
        displayName: "feet",
      },
      lb_d_01_5_0: {
        displayName: "feet",
      },
    },
    item3: {
      lb_d_01_1_0: {
        displayName: "feet",
      },
      lb_d_01_5_0: {
        displayName: "feet",
      },
    },
  },
};

/** customize the displayed name of header row titles e.g. "Producing"
 * that appears in the Pnl Chart HeaderRowTitle component,
 */
export const CUSTOM_PNL_CHART_HEADER_TITLES = {};

type SupervisorContextConfig = {
  /** whether customer has access to C/O checkbox, used to reallocate time to the changeoverDowntime category */
  usesChangeovers: boolean;
  categoriesToApplyChangeoversTo?: string[];
  /** url to google script that allows us to write data to the google sheet, different per processId */
  processConfig: { processId: string; scriptUrl: string }[];
  /** if included, restricts access to supervisor context to only allow these emails */
  allowedEmails?: string[];
};

/** customers who use the trend chart reallocation tool - if the customer is included here, they will have access to the tool */
export const CUSTOMERS_WHO_USE_SUPERVISOR_CONTEXT_TAGGING: {
  [ckey: string]: SupervisorContextConfig;
} = {
  trend_chart_test_user_4: {
    usesChangeovers: true,
    categoriesToApplyChangeoversTo: [
      PnlCategoriesEnum.waiting,
      PnlCategoriesEnum.unplanned,
      PnlCategoriesEnum.planned,
    ],
    processConfig: [
      {
        processId: "test",
        scriptUrl: "",
      },
    ],
  },
  trend_chart_test_user_5: {
    usesChangeovers: false,
    processConfig: [
      {
        processId: "test",
        scriptUrl: "",
      },
    ],
  },
  trend_chart_test_user_6: {
    usesChangeovers: false,
    processConfig: [
      {
        processId: "test",
        scriptUrl: "",
      },
    ],
  },
};

/** custom name and data dump agg value for the customer's parts produced */
type TrendChartOutputConfigType = {
  label: string;
  dataDumpName?: string;
};

// configure the trend chart
type TrendChartConfigType = {
  [ckey: string]: {
    /** horizontal target line height, based on left axis height
     */
    target: number | null | { [processId: string]: number | null };
    /** horizontal target line height, based on right axis height,
     * shows target for current hour & moves up after each hour
     */
    maxOutput: number | null;
    /** use a single object to customize output label and/or data dump value for all processes,
     * or an object to customize individual processes
     */
    output:
      | TrendChartOutputConfigType
      | { [processId: string]: TrendChartOutputConfigType };
    /** use a single object to customize output label and/or data dump value for all processes,
     * or an object to customize individual processes
     */
    outputByProcessGroup?: {
      [processGroup: string]: TrendChartOutputConfigType;
    };
    /** join the trend chart yellow + orange bars into a single bar
     */
    shouldCombineWaitingAndUnplanned?: boolean;
    /** custom category names + colours */
    categories?: { name: string; color: string }[];
    /** skip these categories when calculating the "sum of minutes" number above the bar
     * e.g. ["notScheduled"] will not include grey time in the total minutes
     * indicated on top of the bar
     */
    categoriesNotIncludedInTotalMinutes?: string[];
  };
};

// A future-future midgard
/** @deprecated - prefer midgard flightConfig */
export const TREND_CHART_CONFIG: TrendChartConfigType = {
  renaissance: {
    target: null,
    maxOutput: null,
    output: { label: "Parts" },
  },
  lb: {
    target: null,
    maxOutput: null,
    output: {
      lb_d_01_1_0: { label: "feet" },
      lb_d_01_5_0: { label: "feet" },
    },
    shouldCombineWaitingAndUnplanned: false,
  },
  naturesway: {
    target: null,
    maxOutput: null,
    output: { label: "Parts" },
    shouldCombineWaitingAndUnplanned: false,
  },
  natureswaytwo: {
    target: null,
    maxOutput: null,
    output: { label: "Parts" },
    shouldCombineWaitingAndUnplanned: false,
  },
  nwmason: {
    target: null,
    maxOutput: null,
    output: { label: "Bottles" },
    shouldCombineWaitingAndUnplanned: false,
  },
  nwmason2: {
    target: null,
    maxOutput: null,
    output: { label: "Trays" },
    shouldCombineWaitingAndUnplanned: false,
  },
  pciuk: {
    target: null,
    maxOutput: 30000,
    output: { label: "Parts" },
    shouldCombineWaitingAndUnplanned: false,
  },
  trend_chart_test_user_1: {
    target: null,
    maxOutput: null,
    output: { label: "Parts" },
    categoriesNotIncludedInTotalMinutes: [
      PnlCategoriesEnum.planned,
      PnlCategoriesEnum.notScheduled,
      CHANGEOVER_DOWNTIME,
    ],
  },
  trend_chart_test_user_2: {
    target: 37,
    maxOutput: 125000,
    output: { label: "Parts" },
    categoriesNotIncludedInTotalMinutes: [
      PnlCategoriesEnum.planned,
      PnlCategoriesEnum.notScheduled,
      CHANGEOVER_DOWNTIME,
    ],
  },
  trend_chart_test_user_3: {
    target: 37,
    maxOutput: 125000,
    output: { label: "Parts" },
    shouldCombineWaitingAndUnplanned: true,
    categoriesNotIncludedInTotalMinutes: [
      PnlCategoriesEnum.planned,
      PnlCategoriesEnum.notScheduled,
      CHANGEOVER_DOWNTIME,
    ],
  },
  trend_chart_test_user_4: {
    target: 37,
    maxOutput: 125000,
    output: { label: "Parts" },
    shouldCombineWaitingAndUnplanned: true,
    categoriesNotIncludedInTotalMinutes: [
      PnlCategoriesEnum.planned,
      PnlCategoriesEnum.notScheduled,
      CHANGEOVER_DOWNTIME,
    ],
  },
  trend_chart_test_user_5: {
    target: null,
    maxOutput: 40000,
    output: { label: "Parts" },
    shouldCombineWaitingAndUnplanned: false,
  },
  trend_chart_test_user_6: {
    target: null,
    maxOutput: 4200,
    output: { label: "Parts" },
    shouldCombineWaitingAndUnplanned: false,
  },
  grid_page_story: {
    target: 37,
    maxOutput: 125000,
    output: { label: "Parts" },
    shouldCombineWaitingAndUnplanned: true,
  },
  grid_page_story_pai: {
    target: 37,
    maxOutput: 125000,
    output: { label: "Pallets" },
    shouldCombineWaitingAndUnplanned: false,
  },
  ravenjest: {
    target: 37,
    maxOutput: 125000,
    output: { label: "Pallets" },
    shouldCombineWaitingAndUnplanned: false,
  },
  yamamotoyama: {
    target: null,
    maxOutput: null,
    output: {
      yamamotoyama_d_002: {
        label: "net count",
      },
      yamamotoyama_d_003: {
        label: "net count",
      },
      yamamotoyama_d_004: {
        label: "net count",
      },
      yamamotoyama_d_005: {
        label: "net count",
      },
      yamamotoyama_d_006: {
        label: "net count",
      },
      yamamotoyama_d_007: {
        label: "net count",
      },
      yamamotoyama_d_008: {
        label: "net count",
      },
    },
  },
};

// * FEATURE FLAG
/** A countdown timer appears in place of the typical countup timer
 * on ProcessTile and HubletView for these customers
 * ONLY when in the _producing_ state
 */
export const CUSTOMERS_WITH_PRODUCING_COUNTDOWN_TIMER = [
  "countdown_timer_test_user",
  "metso",
  "countdown_timer_test_user_full_page_story",
];

export const CUSTOMERS_WHO_HIDE_ESTIMATED_LOT_COMPLETION = ["pciuk"];

export const CUSTOMERS_MAX_LOT_DURATION = {
  ravendemo: 10 * 1000,
  DEFAULT: 32 * ONE_DAY_OF_MS,
};

export const CUSTOMERS_LOT_INFO_SCALED_TARGET_RATE = {
  pci: 0.6,
};
export const CUSTOMERS_AHEAD_BEHIND_FIXED_TARGET_RATE = {
  silvercote: {
    silvercote_d_001: 880,
    silvercote_d_002: 880,
    silvercote_d_003: 880,
  },
  "silvercote-duluth": {
    "silvercote-duluth_d_001": 880,
  },
  "silvercote-dallas": {
    "silvercote-dallas_d_001": 880,
    "silvercote-dallas_d_002": 880,
  },
  "silvercote-denver": {
    "silvercote-denver_d_001": 880,
    "silvercote-denver_d_002": 880,
  },
  "silvercote-portland": {
    "silvercote-portland_d_001": 880,
  },
  "silvercote-slc": {
    "silvercote-slc_d_001": 880,
  },
  "silvercote-southcarolina": {
    "silvercote-southcarolina_d_001": 880,
  },
  "silvercote-stockton": {
    "silvercote-stockton_d_001": 880,
  },
  "silvercote-valdosta": {
    "silvercote-valdosta_d_001": 880,
  },
  "silvercote-wrightcity": {
    "silvercote-wrightcity_d_001": 880,
  },
};
export const CUSTOMERS_AHEAD_BEHIND_FIXED_TARGET_RATE_EXCLUDE_NPS = {
  silvercote: {
    silvercote_d_001: true,
    silvercote_d_002: true,
    silvercote_d_003: true,
  },
  "silvercote-duluth": {
    "silvercote-duluth_d_001": true,
  },
  "silvercote-brampton": {
    "silvercote-brampton_d_001": true,
    "silvercote-brampton_d_002": true,
  },
  "silvercote-dallas": {
    "silvercote-dallas_d_001": true,
    "silvercote-dallas_d_002": true,
  },
  "silvercote-denver": {
    "silvercote-denver_d_001": true,
    "silvercote-denver_d_002": true,
  },
  "silvercote-portland": {
    "silvercote-portland_d_001": true,
  },
  "silvercote-slc": {
    "silvercote-slc_d_001": true,
  },
  "silvercote-southcarolina": {
    "silvercote-southcarolina_d_001": true,
  },
  "silvercote-stockton": {
    "silvercote-stockton_d_001": true,
  },
  "silvercote-valdosta": {
    "silvercote-valdosta_d_001": true,
  },
  "silvercote-wrightcity": {
    "silvercote-wrightcity_d_001": true,
  },
};
export const CUSTOMERS_AHEAD_BEHIND_FIXED_TARGET_RATE_EXCLUDE_PLANNED = {
  silvercote: {
    silvercote_d_001: false,
    silvercote_d_002: false,
    silvercote_d_003: false,
  },
  "silvercote-duluth": {
    "silvercote-duluth_d_001": false,
  },
  "silvercote-brampton": {
    "silvercote-brampton_d_001": false,
    "silvercote-brampton_d_002": false,
  },
  "silvercote-dallas": {
    "silvercote-dallas_d_001": false,
    "silvercote-dallas_d_002": false,
  },
  "silvercote-denver": {
    "silvercote-denver_d_001": false,
    "silvercote-denver_d_002": false,
  },
  "silvercote-portland": {
    "silvercote-portland_d_001": false,
  },
  "silvercote-slc": {
    "silvercote-slc_d_001": false,
  },
  "silvercote-southcarolina": {
    "silvercote-southcarolina_d_001": false,
  },
  "silvercote-stockton": {
    "silvercote-stockton_d_001": false,
  },
  "silvercote-valdosta": {
    "silvercote-valdosta_d_001": false,
  },
  "silvercote-wrightcity": {
    "silvercote-wrightcity_d_001": false,
  },
};
export const CUSTOMERS_AHEAD_BEHIND_FIXED_TARGET_RATE_EXCLUDE_UNPLANNED = {
  silvercote: {
    silvercote_d_001: false,
    silvercote_d_002: false,
    silvercote_d_003: false,
  },
  "silvercote-duluth": {
    "silvercote-duluth_d_001": false,
  },
  "silvercote-brampton": {
    "silvercote-brampton_d_001": false,
    "silvercote-brampton_d_002": false,
  },
  "silvercote-dallas": {
    "silvercote-dallas_d_001": false,
    "silvercote-dallas_d_002": false,
  },
  "silvercote-denver": {
    "silvercote-denver_d_001": false,
    "silvercote-denver_d_002": false,
  },
  "silvercote-portland": {
    "silvercote-portland_d_001": false,
  },
  "silvercote-slc": {
    "silvercote-slc_d_001": false,
  },
  "silvercote-southcarolina": {
    "silvercote-southcarolina_d_001": false,
  },
  "silvercote-stockton": {
    "silvercote-stockton_d_001": false,
  },
  "silvercote-valdosta": {
    "silvercote-valdosta_d_001": false,
    "silvercote-valdosta_d_002": false,
  },
  "silvercote-wrightcity": {
    "silvercote-wrightcity_d_001": false,
  },
};

/**
 * Hublet view target count = [ target_rate * (production time - planned time) ],
 * instead of the default [ target rate * production time ]
 * (where production time = "non-NPS" time -- see https://pnl-explorer.netlify.app/ for more definitions) */
export const CUSTOMERS_WHO_SKIP_PLANNED_FROM_TARGET_COUNT = [
  "pciuk",
  "lb",
  "lbprairie",
];

// * Feature Flag
/** larger customers can't reliably use 90-days mode on trends page */
export const CUSTOMERS_TOO_BIG_FOR_90_DAYS = ["pci", "nb", "qi", "qi2", "qi3"];

/** custom list of categories to hide in Other Processes P&L chart */
export const HIDDEN_CATEGORIES_OTHER_PROCESSES_PNL_CHART_PER_CUSTOMER = {};

/** override list of machemetry Ids to show in Other Processes P&L chart by group */
export const OVERRIDE_MACHEMETRY_IDS_FOR_OTHER_PROCESSES_PNL_CHART = {};

/** custom pnl chart titles on timeline page for customers with serial lines */
export const CUSTOM_CONSTRAINT_AND_OTHER_PROCESSES_NAME = {};

/** for now, these only appear on Hublet Page > Hublet View, but it could be applied everywhere */
export const CUSTOMERS_PROCESSES_WITH_CUSTOM_PNL_CATEGORY_NAMES = {};

/** display a simple number input box with title in the group metrics row */
export const CUSTOMERS_WHO_SHOW_EDITABLE_METRIC = {
  nwmason: "OEE Target",
  nwmason2: "OEE Target",
  naturesway: "OEE Target",
  natureswaytwo: "OEE Target",
};

export const CUSTOMERS_CUSTOM_METRIC_EXPLAINER_IMGS: {
  [customer: string]: {
    [dataDumpKey: string]: string;
  };
} = {};

export const CUSTOMERS_WHO_SHOW_FREQUENCY_SUM_IN_PNL_CHART = ["kruger"];

/** in PnlChartColumns > HoursAndMinutes, display a different unit instead of time, this unit replaces one minute, instead of showing h+m*/
export const CUSTOMERS_CUSTOM_DISPLAY_UNITS_MULTIPLIERS: {
  [ckey: string]: {
    [processId: string]: {
      displayName: string;
      unitsPerMinute: number;
    };
  };
} = {};
